<template>
  <div>
    <template v-if="subscribedVisible">
      <div class="subscribed">
        <div
          class="background-overlay-light"
          @click="closeModal"
        />
        <div class="subscribed-wrap">
          <close-icon @click="closeModal" />
          <h3>{{ $t('snippetTemplate.subscribed.subscribedTitle') }}</h3>
          <p>{{ $t('snippetTemplate.subscribed.subscribedDescription') }}</p>

          <button @click="redirectToSuccessPage">
            {{ $t('snippetTemplate.subscribed.subscribedOk') }}
          </button>
        </div>
      </div>
    </template>

    <template v-else-if="alreadySubsribedVisible">
      <div
        class="background-overlay-light"
        @click="closeModal"
      />
      <div class="subscribed-wrap already">
        <close-icon @click="closeModal" />
        <h3>{{ $t('snippetTemplate.alreadySubscribed.alreadySubscribedTitle') }}</h3>
        <p>{{ $t('snippetTemplate.alreadySubscribed.alreadySubscribedDescription') }}</p>
      </div>
    </template>
  </div>
</template>
<script>
  import CloseIcon from 'components/CloseIcon'

  const events = {
    CLOSE: 'close',
    RESEND: 'resend',
    REDIRECT: 'redirect'
  }

  export default {
    components: {
      CloseIcon
    },
    props: {
      subscribedVisible: {
        type: Boolean,
        required: true
      },
      alreadySubsribedVisible: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      resend () {
        this.$emit(events.RESEND)
      },
      closeModal () {
        this.$emit(events.CLOSE)
      },
      redirectToSuccessPage () {
        this.$emit(events.REDIRECT)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .subscribed-wrap {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 468px;
    height: 100%;
    text-align: center;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #ffffff;
    padding: 23px;

    @include bp-mf-tablet {
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      padding: 60px 33px 33px;
      width: 70%;
      height: auto;
      border-radius: 10px;
    }

    &:before {
      @include filled-icon-font();
      content: $filled-icon-checkmark;
      color: $green-base;
      margin: 40px 0 30px;
      width: 100px;
      height: 100px;
      background-color: $grey-white;
      border-radius: 50%;
      font-size: 2.14286em;
      line-height: 105px;
      display: inline-block;
    }

    &.already {

      &:before {
        content: "";
        background: url("~assets/images/subscribe/finish-icon.png") no-repeat;
        position: relative;
        vertical-align: middle;
        text-align: center;
        display: inline-block;
        border-radius: 0;
        width: 107px;
      }
    }

    .close-icon {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: em(16);
      color: $grey;
    }

    h3 {
      font-size: em(21);
      margin-top: 20px;
      margin-bottom: 10px;
    }

    p {
      color: #acacac;
      max-width: 250px;
      margin: 14px auto 36px;
      line-height: 1.65;
    }

    span {
      display: block;
      color: #acacac;
      max-width: 250px;
      font-size: em($base-font-size);
      margin: 50px auto 0 auto;
    }

    div {
      margin-top: 10px;
      cursor: pointer;
      color: $blue-medium;

      &:hover {
        color: $blue-light;
      }
    }

    button {
      border-radius: 6px;
      color: #bac906;
      font-size: 17px;
      width: 164px;
      height: 56px;
      border: 2px solid rgba(205, 220, 16, .75);
    }
  }
</style>
